import React from 'react';
import { connect } from 'react-redux';
import {
  Segment,
  Header,
  Card,
  Image,
} from 'semantic-ui-react';

import { CustomContainer } from '../../common';
import { UserLink } from '../../Links';
import { getUserAvatar } from '../../Utils';

const DEFAULT_TOTAL_NUM = 15;
export const TOP_USER_TYPE = {
  ACTIVE: 'active',
  LIKES: 'likes',
  HATES: 'hates',
};

const getTopUserTypeIndexDef = (type) => {
  switch (type) {
    case TOP_USER_TYPE.ACTIVE:
      return '獲得推/噓/回文總數';
    case TOP_USER_TYPE.LIKES:
      return '推文總數';
    case TOP_USER_TYPE.HATES:
      return '噓文總數';
    default:
      return null;
  }
};

const mapStateToProps = (state) => ({
  browser: state.browser,
});

export default connect(mapStateToProps)(
  ({
    browser,
    data,
    isFetching,
    title,
    total,
    type,
  }) => {
    const isMobile = browser.lessThan.medium;
    const n = data.length;
    if (n === 0 && !isFetching) {
      return (null);
    }

    return (
      <CustomContainer>
        <Header as={isMobile ? 'h3' : 'h2'} attached="top">
          {title || '用戶'}
          <Header.Subheader>一週內</Header.Subheader>
        </Header>
        <Segment
          attached
          padded
          textAlign="left"
          loading={isFetching}
        >
          <Card.Group>
            {
              data
                .slice(0, total || DEFAULT_TOTAL_NUM)
                .map((user) => (
                  <Card
                    key={user.id}
                    centered
                  >
                    <Card.Content>
                      <Image
                        circular
                        floated="right"
                        size="mini"
                        src={getUserAvatar(user.id)}
                      />
                      <Card.Header>
                        <UserLink id={user.id}>
                          {user.id}
                        </UserLink>
                      </Card.Header>
                      <Card.Meta>
                        {user.nickname || '沒有綽號喔'}
                      </Card.Meta>
                      <Card.Description>
                        <b>
                          {getTopUserTypeIndexDef(type)}
                          :
                          {' '}
                          {user.index}
                        </b>
                      </Card.Description>
                    </Card.Content>
                  </Card>
                ))
            }
          </Card.Group>
        </Segment>
      </CustomContainer>
    );
  },
);
